import {
  createClosedUser,
  getClosedUserList,
} from "@/http/setup/closedUserGroup";

export default {
  namespaced: true,
  state: {
    listData: {
      pageItems: [],
    },
  },
  actions: {
    async createClosedUserStatement(data) {
      return await createClosedUser(data);
    },
    async setClosedUserGroup({ commit }) {
      const data = await getClosedUserList();
      commit("CLOSED_USER_GROUP_LIST", data);
    },
  },
  mutations: {
    CLOSED_USER_GROUP_LIST(state, payload) {
      state.listData = payload;
    },
  },
  getters: {
    GetClosedUserList(state) {
      return (
        (state &&
          state.listData &&
          state.listData.data &&
          state.listData.data.pageItems) ||
        []
      );
    },
  },
};
